(function($) {

	Detectizr.detect();

	/*
	=======================================================
		Selectpicker
	=======================================================
	*/

	$('.selectpicker').each(function(){

		var select = $(this);

		select.removeClass('selectpicker');

		select.selectpicker({
			size: false,
			dropupAuto: false
		});

		select.siblings('.bootstrap-select').find('.dropdown-toggle').removeClass('form-control');

		if (typeof select.attr('multiple') != 'undefined') {
			var buttonContainer = $('<li class="btn-container"/>');
			var closeButton = $('<button type="button" class="btn btn-primary btn-block btn-sm">Ok</button>');

			select.siblings('.bootstrap-select').find('> .dropdown-menu .dropdown-menu').append(buttonContainer);
			buttonContainer.append(closeButton);

			closeButton.click(function(){
				select.click();
			});
		}


		// Region Selector
		// -------------------------

		if ($(this).hasClass('website-franchisee-selector--region')) {
			var selectpicker = select.siblings('.bootstrap-select');

			selectpicker.find('.dropdown-header').each(function () {
				$(this).siblings('[data-optgroup="' + $(this).data('optgroup') + '"]').hide();

				$(this).on('click', function (event) {
					event.stopPropagation();
					$(this).toggleClass('open');
					$(this).siblings('[data-optgroup="' + $(this).data('optgroup') + '"]').toggle();
				});
			});

			select.addClass('region-select-picked');
		}
	});

	$('.city-select').citySelector();

	var allPartyTypesOptions = {};

	/**
	 * It updates the party selector on the PArties Inquiry form
	 * to only display the passed valid options
	 *
	 * @param {Array} validOptions
	 * @param {Boolean} refreshSelectPicker - default false
	 */
	function sportballUpdatePartySelectorOptions(validOptions, refreshSelectPicker) {
		if (typeof window['partyTypeSelectorValue'] !== 'undefined') {
			/*
			 * There is the party type selector
			 * Let's update the option values
			 *
			 */
			var partyTypeSelector = $(window.partyTypeSelectorValue);

			var partyTypeSelectorFieldValue = partyTypeSelector.val();

			var partyTypesOptions = partyTypeSelector.find('option[value!=""]');

			// Let's first clean the values
			partyTypesOptions.remove();

			var selectedValueExists = false;

			for(var i = 0 ; i < validOptions.length ; i++) {
				if (typeof allPartyTypesOptions[validOptions[i]] !== 'undefined') {
					partyTypeSelector.append('<option value="' + validOptions[i] + '">' + allPartyTypesOptions[validOptions[i]] + '</option>');

					if (partyTypeSelectorFieldValue == validOptions[i]) {
						selectedValueExists = true;
					}
				}
			}

			if (selectedValueExists) {
				partyTypeSelector.val(partyTypeSelectorFieldValue);
			}
			else {
				partyTypeSelector.val('');
			}

			var refresh = false;

			if ((typeof refreshSelectPicker !== 'undefined') && (refreshSelectPicker)) {
				refresh = true;
			}

			if (refresh) {
				partyTypeSelector.selectpicker('refresh');
			}
		}
	}

	$(document).on('gform_post_render', function(event) {
		/*
		 * We need to check if there is a city selector in the form,
		 * If so, let's add a <li> quite after it as we would like to put it always on the top
		 */
		var formCitySelector = $('[id^="gforms-city-selector"]');

		if (formCitySelector.length > 0) {
			var formCitySelectorListItem = formCitySelector.closest('li.gfield');
			formCitySelectorListItem.after('<li class="gform__city-selector--spacer"></li>')
		}
		else {
			$('li.gfield.gform_hidden').hide();
		}
	});

	$(document).on('gform_post_render.sportball.selectpicker', function (event) {
		var updatePartySelectorOptions = false;

		if (typeof window['partyTypeSelectorValue'] !== 'undefined') {
			/*
			 * There is the party type selector
			 * Let's update the option values
			 *
			 */

			var partyTypeSelector = $(window.partyTypeSelectorValue);

			var partyTypesOptions = partyTypeSelector.find('option[value!=""]');

			for (var i = 0 ; i < partyTypesOptions.length ; i++) {
				allPartyTypesOptions[$(partyTypesOptions[i]).attr('value')] = $(partyTypesOptions[i]).text();
			}

			if (typeof window['websiteFranchiseePartyTypes'] !== 'undefined') {
				// We have a franchisee, so let's list only the party types that exist for the current franchisee
				sportballUpdatePartySelectorOptions(window.websiteFranchiseePartyTypes);
			}
			else {
				/*
				 * Here is the case that the user is not associated with a website franchisee
				 * In this case, we would only filter the value if the region selector
				 * already has a value
				 *
				 * But, let's update it when checking the region selector that exists in the form
				 */
				updatePartySelectorOptions = true;
			}
		}

		$('.gform_wrapper select').hide().each(function(){
			var select = $(this);

			$(this).attr({
				'data-width': '100%',
				'data-style': 'btn-select-alt'
			});

			select.selectpicker();

			if (select.hasClass('website-franchisee-selector--region')) {
				var refreshOnUpdatePartySelectorOptions = false;

				if (!select.hasClass('region-select-picked')) {
					var selectpicker = select.siblings('.bootstrap-select');

					selectpicker.find('.dropdown-header').each(function () {
						$(this).siblings('[data-optgroup="' + $(this).data('optgroup') + '"]').hide();

						$(this).on('click', function (event) {
							event.stopPropagation();
							$(this).toggleClass('open');
							$(this).siblings('[data-optgroup="' + $(this).data('optgroup') + '"]').toggle();
						});
					});

					var selectedItem = selectpicker.find('.selected');

					if (selectedItem.length > 0) {
						selectedItem.toggle();
						selectedItem.siblings('[data-optgroup="' + selectedItem.data('optgroup') + '"]').toggle();
						selectedItem.siblings('.dropdown-header[data-optgroup="' + $(this).data('optgroup') + '"]').toggle();
					}

					refreshOnUpdatePartySelectorOptions = false;
				}

				if (updatePartySelectorOptions) {
					/*
					 * We need to update the values according to the selected website franchisee
					 */
					// Let's get the value
					var selectedWebsiteFranchiseeName = 'All';

					var validPartyTypesOptions = ['Other'];

					if (select.val()) {
						selectedWebsiteFranchiseeName = select.val().replace(/___([0-9]+)___/, '');
					}

					if (typeof window['partyTypesPerWebsiteFranchiseesArray'] !== 'undefined') {
						for(var i = 0 ; i < window.partyTypesPerWebsiteFranchiseesArray.length ; i++) {
							if (selectedWebsiteFranchiseeName == window.partyTypesPerWebsiteFranchiseesArray[i].name) {
								validPartyTypesOptions = window.window.partyTypesPerWebsiteFranchiseesArray[i].types;

								break;
							}
						}
					}

					sportballUpdatePartySelectorOptions(validPartyTypesOptions, refreshOnUpdatePartySelectorOptions);

					// Also, let's attach another handler on the change event
					select.change(function(event) {
						var partyTypeSelector = $(window.partyTypeSelectorValue);

						var selectedWebsiteFranchiseeName = 'All';

						var validPartyTypesOptions = ['Other'];

						if ($(this).val()) {
							selectedWebsiteFranchiseeName = $(this).val().replace(/___([0-9]+)___/, '');
						}

						if (typeof window['partyTypesPerWebsiteFranchiseesArray'] !== 'undefined') {
							for(var i = 0 ; i < window.partyTypesPerWebsiteFranchiseesArray.length ; i++) {
								if (selectedWebsiteFranchiseeName == window.partyTypesPerWebsiteFranchiseesArray[i].name) {
									validPartyTypesOptions = window.window.partyTypesPerWebsiteFranchiseesArray[i].types;

									break;
								}
							}
						}

						// Let's update the selector
						sportballUpdatePartySelectorOptions(validPartyTypesOptions, true);
					});
				}
			}
		});
	});


	/*
	=======================================================
		Tabbed Navigation flaps
	=======================================================
	*/

	$(document).on('onUpdatePrograms onLoadPrograms', 'body', function(event) {
		$('.nav-tabs > li > a').each(function () {
			if (!$(this).hasClass('flap-tab')) {
				$(this).addClass('flap-tab')
					.wrapInner('<span class="flap-title"></span>')
					.prepend('<span class="flap-left"><span class="flap-bottom"></span></span>')
					.append ('<span class="flap-right"><span class="flap-bottom"></span></span>');
			}
		});
	});



	/*
	=======================================================
		Google Maps
	=======================================================
	*/

	var googleMapsOnLoad = function () {
		var script = $('<script>').attr({
			'type': 'text/javascript',
            'src': 'https://maps.googleapis.com/maps/api/js?v=3.26&libraries=places&callback=gMapsAPIReady' +
            (window.appConfig.googleApiKey ? '&key=' + window.appConfig.googleApiKey : '')
		});

		$('body').append(script);
	};

	gMapsAPIReady = function () {
		window.googleMapsAPIReady = true;
		$(document).trigger('googleMapsAPIReady');
	};

	$(window).on('load', googleMapsOnLoad);



	/*
	============================================================
		YouTube iframe API
	============================================================
	*/

	var youtubeIframeAPIElement = document.createElement('script');

	youtubeIframeAPIElement.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(youtubeIframeAPIElement, firstScriptTag);

	onYouTubeIframeAPIReady = function () {
		$('body').trigger('youTubeAPIReady');
	};



	/*
	============================================================
		Checkboxes
	============================================================
	*/

	$('body').on('change', 'input[type="checkbox"], input[type="radio"]', function () {
		$(this).attr('checked', $(this).is(':checked'));
	});



	/*
	============================================================
		Add "(First/Last) Name"  to Gravity Forms' name fields
	============================================================
	*/

	$('.field-name').each(function () {
		var label = $(this).find('.ginput_complex label');

		if ($('html').attr('lang') === 'en-US') {
			label.each(function () {
				$(this).html($(this).text() + ' Name');
			});
		}

		if ($(this).hasClass('gfield_contains_required')) {
			label.append('<span class="gfield_required">*</span>');
		}
	});

	$('.gfield:not(.field-name) .ginput_complex input').each(function () {
		var label = $(this).siblings('label').text();
		$(this).attr('placeholder', label);
	});

	/*
	============================================================
		Gravity Forms Child Birthdate filters
	============================================================
	*/
	$(document).on('gform_post_render', function(event) {
		if (typeof window['gform'] !== 'undefined') {
			gform.addFilter('gform_datepicker_options_pre_init', function(options, formId, fieldId) {
				var childBirthdateFields = null;

				if (typeof window.appConfig['gravityForms'] !== 'undefined') {
					if (typeof window.appConfig.gravityForms['childBirthdateFormFields'] !== 'undefined') {
						childBirthdateFields = window.appConfig.gravityForms.childBirthdateFormFields;

						if (typeof childBirthdateFields[formId] !== 'undefined') {
							var currentDate = new Date();

							for(var i = 0 ; i < childBirthdateFields[formId].length ; i++) {
								var formFieldId = childBirthdateFields[formId][i];

								var defaultYear = currentDate.getFullYear() - 16;

								var defaultMonth = currentDate.getMonth() + 1;
								defaultMonth = (defaultMonth < 10 ? '0'.concat(defaultMonth) : defaultMonth);

								var defaultDay = currentDate.getDate();
								defaultDay = (defaultDay < 10 ? '0'.concat(defaultDay) : defaultDay);

								if (formFieldId == fieldId) {
									// This is a child birthdate field
									options.defaultDate = defaultMonth + '/' + defaultDay + '/' + defaultYear;
									// Let's also setup the year range
									options.yearRange = defaultYear + ':' + currentDate.getFullYear();
								}
							}
						}
					}
				}

				return options;
			});
		}
	});

	/*
	============================================================
		Website Franchisee Selector
	============================================================
	*/
	$(document).on('change', 'select[name="website-franchisee-selector"]', function(event) {
		if (!$(this).data('gforms-field-id')) {
			// Normal behavior
			if (($(this).val() != window.location.host)) {
				// It is a different country (different host)
				location.href = $(this).val();
			}
			else if ($(this).val()) {
				// Redirect the user to the new city
				var newUrl = $(this).val();

				var currentUrl = window.location.pathname;

				var modifiedProgramSchedulesPosition = currentUrl.indexOf('/program-schedules');

				if (currentUrl.indexOf('/program-schedules') != -1) {
					// Ok, let's append the current filter values in the link
					var modifiedFilters = window.location.pathname.substr(modifiedProgramSchedulesPosition + '/program-schedules'.length);

					if (modifiedFilters.charAt(0) == '/') {
						modifiedFilters = modifiedFilters.substr(1);
					}

					// Let's remove the current region
					var modifiedFiltersParts = modifiedFilters.split('/');

					modifiedFiltersParts = modifiedFiltersParts.slice(1);

					var locationSearchForm = $('#location-search-form');

					// Now let's remove the location search value, if it has one
					if (locationSearchForm.data('location-search-value')) {
						if (locationSearchForm.data('location-search-value') != '') {
							var decrement = -1;

							if (modifiedFiltersParts[modifiedFiltersParts.length - 1] == '') {
								// The "/" is the last char
								decrement = -2;
							}

							modifiedFiltersParts = modifiedFiltersParts.slice(0, modifiedFiltersParts.length + decrement);
						}
					}

					modifiedFilters = modifiedFiltersParts.join('/');

					var queryString = "";

					var queryStringStartPosition = newUrl.indexOf('?');

					if (queryStringStartPosition != -1) {
						queryString = newUrl.substr(queryStringStartPosition);

						newUrl = newUrl.substr(0, queryStringStartPosition);
					}

					if (newUrl.charAt(newUrl.length - 1) == '/') {
						newUrl = newUrl.substr(0, newUrl.length - 1);
					}

					newUrl = newUrl + '/' + modifiedFilters + queryString;
				}

				location.href = newUrl;
			}
		}
		else {
			// Let's update the franchisee field id
			var websiteFranchiseeField = $('#' + $(this).data('gforms-field-id'));

			var websiteFranchiseeRegionIdField = $('#websiteFranchiseeRegionId');

			if ($(this).val()) {
				var regionIdRegularExpression = /___([0-9]+)___/;

				websiteFranchiseeField.val($(this).val().replace(regionIdRegularExpression, ''));

				var macthedValues = regionIdRegularExpression.exec($(this).val());

				// Let's use the id and update the field
				websiteFranchiseeRegionIdField.val(macthedValues[1]);
			}
			else {
				websiteFranchiseeField.val('');

				websiteFranchiseeRegionIdField.val('');
			}

		}
	});


	/*
	============================================================
		Become a Franchisee Website Franchisee Selector
	============================================================
	*/
	$(document).on('change', 'select[name="becomeACoachWebsiteFranchisee"]', function(event) {
		$(this).closest('form').submit();
	});

	/*
	============================================================
		Mobile menu Franchisee Display
	============================================================
	*/

	$(document).on('click', '.franchisee-display__edit', function () {
		var franchiseeDisplayContainer = $('.franchisee-display');

		franchiseeDisplayContainer.toggleClass('open');

		if (franchiseeDisplayContainer.hasClass('open')) {
			$(this).html($(this).data('close-text'));
		}
		else {
			$(this).html($(this).data('open-text'));
		}
	});


	/*
	============================================================
		RoyalSlider
	============================================================
	*/

	$(document).on('ready loaded.bs.modal', function() {
		$('.gallery').each(function () {
			$(this).royalSlider({
				controlNavigation: 'thumbnails',
				autoScaleSlider: true,
				autoScaleSliderWidth: 3,
				autoScaleSliderHeight: 2,
				loop: false,
				imageScaleMode: 'fit',
				imageScalePadding: 0,
				navigateByClick: true,
				numImagesToPreload: 2,
				arrowsNav: true,
				arrowsNavAutoHide: true,
				arrowsNavHideOnTouch: true,
				keyboardNavEnabled: true,
				fadeinLoadedSlide: true,
				globalCaption: $(this).hasClass('modal-body__gallery'),
				thumbs: {
					fitInViewport: false,
					appendSpan: true,
					firstMargin: false,
					paddingBottom: 0
				}
			});

			$(this).closest('.modal').trigger('resize.bs.modal.center');
		});
	});



	/*
	============================================================
		Prevent mobile menu dropdown item click from closing
		the dropdown
	============================================================
	*/

	$('.navbar-nav .dropdown-menu a').on('click', function (e) {
		e.stopPropagation();
	});



	/*
	============================================================
		Twitter load
	============================================================
	*/

	$(document).on('twitter-load', function (jQueryEvent, twitterEvent) {
		var target = $(twitterEvent.target);
		var parent = target.closest('.testimonial, .testimonial-wall-entry');

		if (parent.length === 1) {
			var contents = target.contents();
			contents.find('head').append('<style>.p-geo b {display: none !important;}</style>');

			if (parent.hasClass('testimonial-wall-entry')) {
				contents.find('head').append('<style>.EmbeddedTweet, .MediaCard-borderOverlay, .EmbeddedTweet-tweet{border: 0 !important;}</style>');
			}

			var check = function () {
				if (contents.height() > 0) {
					target.height(contents.find('html').height());
				}
				else {
					setTimeout(check, 500);
				}
			};

			check();

			$(window).on('resize', function () {
				target.height(contents.find('html').height());
			});
		}
	});



	/*
	============================================================
		Fixed navigation
	============================================================
	*/

	$('.navbar-collapse').fixedNav();



	/*
	============================================================
		Mobile menu Old Website options tracking
	============================================================
	*/

	(function () {
		var oldWebsiteClicksCookieName = 'sportballOldWebsiteCliks';
		var oldWebsiteClicks = (typeof $.cookie(oldWebsiteClicksCookieName) !== 'undefined' ? parseInt($.cookie(oldWebsiteClicksCookieName)) : 0);

		var gaTracker = null;
		var gaEventCategory  = 'Soft Launch Bar';

		var oldWebsiteButton = $('#mobile-nav-old-website');
		var feedbackButton = $('#mobile-nav-feedback');

		if (typeof DbbGoogleAnalyticsTracker !== 'undefined') {
			gaTracker = new DbbGoogleAnalyticsTracker();
		}

		oldWebsiteButton.on('click', function () {
			$.cookie(oldWebsiteClicksCookieName, ++oldWebsiteClicks, {path: '/', expires: 3650});

			if (gaTracker !== null) {
				gaTracker.trackEvent(gaEventCategory, 'Downgrade', document.title, oldWebsiteClicks);
			}
		});

		feedbackButton.on('click', function() {
			if (gaTracker !== null) {
				gaTracker.trackEvent(gaEventCategory, 'Feedback', document.title);
			}
		});
	})();



	/*
	============================================================
		Upload file input
	============================================================
	*/

	$(document).on('ready.sportball.inputFile', function () {
		$('input[type="file"]').inputFile();
	});



	/*
	============================================================
		Tooltips
	============================================================
	*/

	$('[data-toggle="tooltip"]').tooltip();



	/*
	============================================================
		Location Search input
	============================================================
	*/

	$('.location-search-string').each(function () {
		var locationSearchInput = $(this);

		var locationSearchInputChange = function () {
			if (locationSearchInput.val() == '') {
				locationSearchInput.addClass('is-empty');
			}
			else {
				locationSearchInput.removeClass('is-empty');
			}
		};

		$('body').on('onLocationSearchReset onLocationSearchChange', function () {
			locationSearchInputChange();
		});

		$(this).on('change', function () {
			locationSearchInputChange();
		});

		locationSearchInputChange();
	});

	/*
	============================================================
		Setup specific program sidebar top margin
	============================================================
	*/
	$('.sidebar-module--program').css('margin-top', $('.page-header.main-header').outerHeight() + 'px');




	/*
	============================================================
		Homepage slider video player
	============================================================
	*/

	$('.brick-wall').each(function () {

		var player;
		var brickWallElement = $(this);
		var playerContainer = $('#videoBrickPlayerContainer');
		var playerRatio = $('#videoBrickPlayerRatio');
		var brickWallObject = brickWallElement.data('brickWall');
		var videoBrickElements = brickWallElement.find('.brick--video-thumb');
		var closeButton = $('#videoBrickCloseButton');
		var playButton = $('#videoBrickPlayButton');
		var loadingIndicatorContainer = $('.brick-wall-video-loading-indicator-container');
		var autoplayEnabled = playerContainer.data('autoplay');

		if (videoBrickElements.length === 0) {
			return;
		}


		// Video Player
		// ---------------------------

		// Creates and appends the YT Frame API script to the document
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		document.body.appendChild(tag);

		var resizeVideoPlayerRatioContainer = function () {

			if (!(isBreakpoint('xs') || isBreakpoint('sm')) &&
				((playerContainer.height() / playerContainer.width()) >= 0.5625)) {
				playerRatio.width(playerContainer.height() / 0.5625);
			}
			else {
				playerRatio.width('100%');
			}

		};

		resizeVideoPlayerRatioContainer();

		$(window).on('resize.brickWallVideoPlayer', resizeVideoPlayerRatioContainer);

		var videoIsPlaying = false;

		var playVideo = function () {

			videoIsPlaying = true;

			loadingIndicatorContainer.addClass('loading');

			brickWallObject.stopSlider();
			brickWallObject.unregisterBreakpointEvents();
			player.seekTo(0); // make sure we rollback because we never really stop the video
			player.playVideo();
			playButton.removeClass('is-active');

			$(window).off('breakpointChange.brickwall focus.brickwall blur.brickwall')
				.on('breakpointChange.brickwall', function() {
					brickWallObject.breakpointChange();
					brickWallObject.setCurrentSlide(1);
					brickWallObject.setNextSlide(2);
					brickWallObject.updateCurrentAndNextBricks();
					brickWallObject.updateIndicatorsState();

					if (brickWallObject.getCurrentSlide() === 4) {
						playButton.addClass('is-active');
					}
				});

		};

		var stopVideo = function () {

			playerContainer.removeClass('is-active');
			playButton.addClass('is-active');

			if (videoIsPlaying) {

				brickWallObject.registerBreakpointEvents(window.breakpoint);

				$(window)
					.off('breakpointChange.brickwall focus.brickwall blur.brickwall')
					.on('breakpointChange.brickwall', function() {
						brickWallObject.breakpointChange().playSlider();
					})
					.on('focus.brickwall', function () {
						brickWallObject.playSlider();
					})
					.on('blur.brickwall', function () {
						brickWallObject.stopSlider();
					});

				// if we stop the video it rolls back to the first frame and the fadeout effect
				// gets very weird
				player.pauseVideo();

			}

		};

		var playerReady = function (event) {

			brickWallElement
				.on('flipEnd.brickWallVideoPlayer', function () {

					if (brickWallObject.getCurrentSlide() === 4) {
						playButton.addClass('is-active');
					}

				});

			brickWallElement.on('flipStart.brickWallVideoPlayer', function () {

				stopVideo();

				if (brickWallObject.getNextSlide() !== 4) {
					playButton.removeClass('is-active');
				}

			});

			$(window).on('breakpointChange.brickWallVideoPlayer', function () {

				playButton.addClass('is-active');

			});

			playButton.add('.brick--video-link .brick__link')
				.on('click.brickWallVideoPlayer', function (event) {

					event.preventDefault();

					player.unMute();

					playVideo();

				});

			closeButton.on('click.brickWallVideoPlayer', function (event) {

				event.preventDefault();

				player.unMute();

				stopVideo();

			});

			player.mute();

			if (autoplayEnabled && !isBreakpoint('xs')) {
				player.seekTo(0);
				playVideo();
			}

			if (!autoplayEnabled) {
				// playButton.addClass('is-active');
				brickWallObject.playSlider();
			}

		};

		var playerStateChange = function (event) {

			if (event.data === window.YT.PlayerState.PLAYING) {
				loadingIndicatorContainer.removeClass('loading');
				playerContainer.addClass('is-active');
			}
			else if (event.data === window.YT.PlayerState.PAUSED) {
				player.unMute();
			}
			else if (event.data === window.YT.PlayerState.ENDED) {
				stopVideo();
			}

		};


		/**
		 * Default listener for the YT Iframe API
		 */
		function onYouTubeIframeAPIReady () {

			player = new window.YT.Player('videoBrickPlayer', {
				videoId: playerContainer.data('videoId'),
				suggestedQuality: 'hd1080',
				playerVars: {
					autoplay: 0,
					controls: 0,
					rel : 0,
					showinfo: 0,
					modestbranding: 1,
					fs: 0,
					iv_load_policy: 3,
					cc_load_policy: 0,
					allowfullscreen: 0,
					wmode: 'transparent',
					disablekb: 1
				},
				events: {
					onReady: playerReady,
					onStateChange: playerStateChange
				}
			});

		}

		// Export the listener to the window object so the API can find it
		window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

	});



})(window.jQuery);
